var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"navbar"},[_c('div',{staticClass:"routes-wrapper"},_vm._l((_vm.routes),function(r){return _c('span',{key:r.route,staticClass:"page-btn text-color",class:{
        selected: _vm.currentRoute.name.toLowerCase() == r.route.toLowerCase(),
      },on:{"click":function($event){return _vm.goToPage(r.route)}}},[_vm._v(_vm._s(r.title))])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }